import React, { useState, useContext } from 'react'; 
import '../assets/css/styles.css';
import "../assets/css/AboutUs.css";
import { LanguageContext } from '../contexts/LanguageContext';
import HighlightsCarousel from '../components/HighlightsCarousel';
import Alobwede from '../assets/images/alobwede1.png';
import Makay from '../assets/images/makay.png';
import { t } from 'i18next';

const HeroSection = ({ title, subtitle }) => (
  <header className="hero">
    <div className="hero-overlay">
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  </header>
);

const IntroSection = () => {
  const { t } = useContext(LanguageContext);
    return (
      <div className="intro-overlay">
        <p>
          {t.about_description_p_1}
          <br /><br />
          {t.about_description_p_2}
        <br /><br />
        {t.about_description_p_3}
      </p>
    </div>
  );
}

const MissionVision = () => {
  const { t } = useContext(LanguageContext);

  return  (
    <section className="mission-vision container">
      <div className="mission card">
        <h2>{t.our_mission}</h2>
        <p>
          {t.mission_description_p_1}<br></br> {t.mission_description_p_2}
        </p>
      </div>
      <div className="vision card">
        <h2>{t.our_vision}</h2>
        <p>
          {t.vision_description}
        </p>
      </div>
      <div className="vision card">
        <h2>{t.social_responsibility}</h2>
        <p>
          {t.social_responsibility_description_p_1}<br></br>{t.social_responsibility_description_p_2}<br></br>
          {t.social_responsibility_description_p_3}
        </p>
      </div>
      <div className="vision card">
        <h2>{t.our_history}</h2>
        <p>
          {t.history_description_p_1}<br /><br />{t.history_description_p_2}
        </p>
      </div>
    </section>
  );
}

const teamData = [
  { 
    name: "Makarios Mbundoh Akembuom", 
    title: "Chief Executive Officer", 
    img: "" || Makay,
    bio: "Experienced leader with over 20 years in security industry.",
    experience: "● Labogenie - 7 years. Wackenhut Cameroon - 10 years. ● Essoka Security - 20 years. ● Current Member of ASIS (World’s Largest Security Organiztion).",
    expertise: ["Security Consulting", "Public Law Enforcement", "Leadership"],
    email: "makarios.mbundoh@3sss.cm",
    linkedin: "https://linkedin.com/in/makarios"
  },
  { 
    name: "Lufong George Yuven", 
    title: "HSO (Head of Strategic Operations)", 
    img: "",
    bio: "Operations expert specializing in process optimization and strategic implementation over 20 years.",
    experience: "● X Security Liaison Officer Cotco. ● X Chief of Operations G4s. ● X Security Sub Director / Chief of Operations ENEO. ● X Head of Corporate Security Guinness Diageo/SABC.",
    expertise: ["Operations Management", "Process Optimization", "Strategic Implementation"],
    email: "george.lufong@3sss.cm",
    linkedin: "https://linkedin.com/in/lufong"
  },
  { 
    name: "Nsonagai Paul Mbeh", 
    title: "Operations Manager", 
    img: "",
    bio: "Detail-oriented operations professional with a track record of improving efficiency.",
    experience: "● Humanitarian, Access, Safety and Security Professional ( HASSM). ● Certified TOT Trainer. ● BA. Linguistics Yde I & MSC. Security Studies, CUU Uganda.",
    expertise: ["Project Management", "Operational Efficiency", "Team Coordination"],
    email: "paul.nsonagai@3sss.cm",
    linkedin: "https://linkedin.com/in/paul-mbeh"
  },
];

const advisoryCouncil = [
  { 
    name: "Paul E Alobwede", 
    title: "Advisory Role", 
    img: Alobwede,
    bio: "Seasoned advisor with extensive experience in criminology, public law enforcement, and retail security.",
    academics: "● Master of Arts degree in Criminology, Rutgers University School of Law and Justice, Newark New Jersey. ● ⁠Advanced Diploma, Retail Security and Public Law Enforcement, Montclair State University Bloomfield, New Jersey. ● ⁠Bachelor of Arts degree in Criminal Justice, State University of New York at Oswego, New York",
    experience: "● Country Director, Inter-Con Security (position proposed by Inter-Con Corporate Office and approved by USA Government Department of State for Diplomatic Security).⁠ Project Manager. ● G4S/US Embassy Cameroon Guard Force (position proposed by G4S International head office and approved by USA Government Department of State for Diplomatic Security). ● ⁠Area Manager, Wackenhut International Cameroon. ⁠Operations Manager, Wackenhut Security Cameroon.",
    expertise: ["Criminology", "Public Law Enforcement", "Retail Security"],
    email: "paul.alobwede@company.com",
    linkedin: "https://linkedin.com/in/paul-alobwede"
  },
  ...teamData,
  { 
    name: "Jane Doe", 
    title: "Legal Advisor", 
    img: "",
    bio: "Corporate law expert specializing in regulatory compliance and risk management.",
    experience: "JD from Harvard Law, 12+ years in corporate law",
    expertise: ["Corporate Law", "Regulatory Compliance", "Risk Management"],
    email: "jane.doe@company.com",
    linkedin: "https://linkedin.com/in/jane-doe"
  },
  { 
    name: "John Smith", 
    title: "Cybersecurity Specialist", 
    img: "",
    bio: "Cybersecurity expert with experience in protecting enterprise systems and data.",
    experience: "CISSP certified, 10+ years in cybersecurity",
    expertise: ["Information Security", "Risk Assessment", "Security Architecture"],
    email: "john.smith@company.com",
    linkedin: "https://linkedin.com/in/john-smith-security"
  },
  { 
    name: "Anna Ngu", 
    title: "Policy Advisor", 
    img: "",
    bio: "Policy expert with deep understanding of regulatory frameworks and government relations.",
    experience: "Former government official, PhD in Public Policy",
    expertise: ["Policy Development", "Government Relations", "Regulatory Affairs"],
    email: "anna.ngu@company.com",
    linkedin: "https://linkedin.com/in/anna-ngu"
  },
  { 
    name: "Dr. Emmanuel T.", 
    title: "Crisis Management Expert", 
    img: "",
    bio: "Crisis management specialist with expertise in business continuity and emergency response.",
    experience: "PhD in Crisis Management, 15+ years consulting experience",
    expertise: ["Crisis Management", "Business Continuity", "Emergency Response"],
    email: "emmanuel.t@company.com",
    linkedin: "https://linkedin.com/in/dr-emmanuel-t"
  },
];

// Member Details Modal Component
const MemberModal = ({ member, show, onClose }) => {
  const { t } = useContext(LanguageContext);
  
  if (!show || !member) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="member-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-content">
          <div className="member-profile">
            <div className="member-image-container">
              <img 
                src={member.img || '/api/placeholder/150/150'} 
                alt={member.name}
                className="member-image"
              />
            </div>
            
            <div className="member-info">
              <h2>{member.name}</h2>
              <h3 className="member-title">{member.title}</h3>
              
              <div className="member-section">
                <h4>Biography</h4>
                <p>{member.bio}</p>
              </div>

              <div className="member-section">
                <h4>Academics</h4>
                <p>{member.academics}</p>
              </div>
              
              <div className="member-section">
                <h4>Experience</h4>
                <p>{member.experience}</p>
              </div>
              
              <div className="member-section">
                <h4>Areas of Expertise</h4>
                <div className="expertise-tags">
                  {member.expertise?.map((skill, index) => (
                    <span key={index} className="expertise-tag">{skill}</span>
                  ))}
                </div>
              </div>
              
              <div className="member-section">
                <h4>Contact</h4>
                <div className="contact-info">
                  {member.email && (
                    <a href={`mailto:${member.email}`} className="contact-link">
                      📧 {member.email}
                    </a>
                  )}
                  {member.linkedin && (
                    <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link">
                      💼 LinkedIn Profile
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeamSection = ({ onMemberClick }) => {
  const { t } = useContext(LanguageContext);
  return (
    <section className="team container">
      <h2 className="section-title">{t.our_executive_team}</h2>
      <p>{t.team_description}</p>
      <div className="team-grid">
        {teamData.map((m) => (
          <article className="team-card clickable-card" key={m.name} onClick={() => onMemberClick(m)}>
            <img src={m.img} alt={m.name} />
            <h3>{m.name}</h3>
            <p>{m.title}</p>
            <div className="view-more-hint">Click for more info</div>
          </article>
        ))}
      </div>
    </section>
  );
}

const ExpertSection = ({ onShowMore, onMemberClick }) => {
  const { t } = useContext(LanguageContext);
  const [showPanel, setShowPanel] = useState(false);

  return (
    <section className="team container">
      <h2 className="section-title">{t.advisory_counsel}</h2>
      <p>{t.advisory_counsel_description}</p>
      <div className="team-grid">
        {advisoryCouncil.slice(0, 3).map((m) => (
          <article className="team-card clickable-card" key={m.name} onClick={() => onMemberClick(m)}>
            <img src={m.img} alt={m.name} />
            <h3>{m.name}</h3>
            <p>{m.title}</p>
            <div className="view-more-hint">Click for more info</div>
          </article>
        ))}
      </div>
      <div className="text-center mt-3">
        <button className="see-more-btn" onClick={onShowMore}>{t.advisory_counsel_btn}</button>
      </div>
      {showPanel && <div className="slide-panel-backdrop" onClick={() => setShowPanel(false)} />}
    </section>
  );
}

// Updated Sliding Panel Component
const SlidePanel = ({ show, onClose, onMemberClick }) => {
  const { t } = useContext(LanguageContext);
  const [query, setQuery] = useState('');
  const filtered = advisoryCouncil.filter(m =>
    m.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className={`slide-panel ${show ? 'show' : ''}`}>
      <div className="slide-header">
        <h3>{t.advisory_counsel_members}</h3>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
      <div className="slide-body">
        <input
          type="text"
          placeholder={t.search_placeholder}
          value={query}
          onChange={e => setQuery(e.target.value)}
          className="search-input"
        />
        <div className="team-grid">
          {filtered.map((m) => (
            <article className="team-card clickable-card" key={m.name} onClick={() => onMemberClick(m)}>
              <img src={m.img} alt={m.name} />
              <h3>{m.name}</h3>
              <p>{m.title}</p>
              <div className="view-more-hint">Click for more info</div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default function AboutUs() {
  const { t } = useContext(LanguageContext);
  const [showPanel, setShowPanel] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showMemberModal, setShowMemberModal] = useState(false);

  const handleMemberClick = (member) => {
    setSelectedMember(member);
    setShowMemberModal(true);
  };

  const closeMemberModal = () => {
    setShowMemberModal(false);
    setSelectedMember(null);
  };

  return (
    <>
      <HeroSection title={t.who_we_are} subtitle="" />
      <IntroSection />
      <MissionVision />
      <TeamSection onMemberClick={handleMemberClick} />
      <ExpertSection 
        onShowMore={() => setShowPanel(true)} 
        onMemberClick={handleMemberClick}
      />
      <SlidePanel 
        show={showPanel} 
        onClose={() => setShowPanel(false)}
        onMemberClick={handleMemberClick}
      />
      <MemberModal 
        member={selectedMember}
        show={showMemberModal}
        onClose={closeMemberModal}
      />
      <div className="news-section">
        <p>{t.our_blog}</p>
        <h2>
          <span className="highlight">{t.news_section_highlight}</span> {t.news_section_opening}
        </h2>
        <p className="opening">{t.news_section_description}</p>
        <HighlightsCarousel />
      </div>
    </>
  );
}